import { useTranslation } from 'react-i18next';

import CustomButton from '../../../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import { TRANSLATIONS_CLIENTS } from '../../../../../../../../shared/translations/clients';

interface IClientDataCardErrorProps {
  onRetry: () => void;
}

const ClientDataCardError = ({ onRetry }: IClientDataCardErrorProps) => {
  const { t } = useTranslation();

  return (
    <div className="client-data-card__section">
      <p className="profile-card__empty-hint">{t(TRANSLATIONS_CLIENTS.profile.contacts.error)}</p>
      <CustomButton size="s" variant="default" onClick={onRetry}>
        {t(TRANSLATIONS_CLIENTS.clientsList.states.error.retry)}
      </CustomButton>
    </div>
  );
};

export default ClientDataCardError;
